import { uiFactory } from "@/ui";
import { useAuth } from "@/store/auth";
import { useStation } from "camera/store/station";
import StatusBar from "camera/modules/station/components/StatusBar";
import NoPermissons from "./NoPermissons";
import NoDevicesAvailable from "./NoDevicesAvailable";
import WarningOverlay from "./WarningOverlay";
import CameraOff from "./CameraOff";
import { CameraStore } from "camera/store/camera";

const EnhancedVideo = uiFactory("video");

type Props = {
  loading: boolean;
  error: CameraStore["error"] | null;
  ref?: React.Ref<HTMLVideoElement>;
};

export default function Video({ loading, error, ref }: Props) {
  const deviceName = useAuth((state) => state.device.name);
  const recordingMode = useStation((state) => state.recordingMode);

  const isCameraOff = recordingMode === "OFF";
  return (
    <>
      {!loading && <StatusBar />}
      {(loading || error || isCameraOff) && (
        <WarningOverlay deviceName={deviceName}>
          {isCameraOff && <CameraOff />}
          {error === "permission_denied" && <NoPermissons />}
          {error && error !== "permission_denied" && <NoDevicesAvailable />}
        </WarningOverlay>
      )}
      <EnhancedVideo
        ref={ref}
        id="camera-video"
        autoPlay
        playsInline
        muted
        w="100%"
        borderRadius="24px"
        transform="scaleX(-1)"
      />
    </>
  );
}
